import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import Sharing from '@ad/ad_utils_react/src/components/business/TTCX/AssetManagement/Sharing';
import { checkSuccessResponse, sendCustomEvent } from '@ad/ad_utils/src';
import { apis } from '@/pages/asset/apis';
import { globalInfoStore } from '@/models/global';
import { usePersistFn } from '@/utils/hooks/common';
import commonApis from '@/apis/commonApis';
import { Page } from '@/utils/logger/event-tracking';
import { PageEnum } from '@/utils/logger/event-tracking/types';

function SharingPage() {
  const searchAdv = usePersistFn(async (advId: string) => {
    const res = await commonApis.getAdvInfos({
      advIds: [advId]
    });
    if (!checkSuccessResponse(res.code)) {
      return;
    }
    return (res.data?.advInfos || []).map((item) => ({
      id: item.advId,
      name: item.advName
    }));
  });

  return (
    <Page page={PageEnum.AssetsSharing}>
      <Sharing
        sendCustomEvent={sendCustomEvent}
        shareLink={window.location.pathname}
        apis={apis}
        store={globalInfoStore}
        onSearchAdv={searchAdv}
      />
    </Page>
  );
}

export default observer(SharingPage);
